<template>
  <div>
    <div v-if="playlist.length > 0">
      <div v-for="(video, index) in playlist" :key="index">
        <div
          v-if="!video.episode"
          :class="'row row-playlist video_id_' + video.id + ' '"
          id="single-item-playlist"
        >
          <div
            class="flex-col playlist-song"
            style="position: relative"
            @click="goToVideo(video)"
          >
            <a
              :href="`/user/playlist/video/${video.playlist_id}?video=${video.item_id}`"
              style="display: flex"
            >
              <img
                :src="
                  paths.portraitPath + video?.item?.image?.portrait ??
                  paths.default
                "
                :alt="video.item.title"
              />
              <span class="playlist-song-title">
                <p
                  style="
                    margin: 0 !important;
                    padding: 0 !important;
                    color: #fff !important;
                  "
                >
                  {{ video.item.title }}
                </p>
                {{ video.item.creator.name }}
              </span>
            </a>
            <div
              class="dropdown float-right"
              @click.stop
              style="
                float: right;
                background: transparent !important;
                border: none;
                position: absolute;
                right: 0;
                top: 0;
                margin-right: 10px;
              "
            >
              <button
                class="btn btn-secondary dropdown-toggle remove-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i
                  class="fa fa-ellipsis-v dropdown-toggle"
                  id="icon-open-modal-options"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></i>
              </button>
              <ul
                class="dropdown-menu drop-shadow-none dropdown-options"
                aria-labelledby="dropdownMenuButton1"
                style="z-index: 1000"
              >
                <li>
                  <div
                    class="dropdown-item"
                    id="remove-to-playlist"
                    :data-video-id="video.id"
                    :data-playlist-id="video.playlist_id"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title=""
                    data-original-title="Remove to Playlist"
                    @click="removeToPlaylist(video.id, video.playlist_id)"
                  >
                    Remove to Playlist
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-else
          :class="'row row-playlist video_id_' + video.id + ' '"
          id="single-item-playlist"
        >
          <div
            class="flex-col playlist-song"
            style="position: relative"
            @click="goToEpisode(video)"
          >
            <a
              :href="`/user/playlist/video/${video.playlist_id}?video=${video.episode_id}`"
              style="display: flex"
            >
              <img
                :src="
                  paths.episodePortraitPath + video?.episode?.image?.portrait ??
                  paths.default
                "
                :alt="video.episode.title"
              />
              <span class="playlist-song-title">
                <p
                  style="
                    margin: 0 !important;
                    padding: 0 !important;
                    color: #fff !important;
                  "
                >
                  {{ video.episode.title }}
                </p>
                {{ video.episode.item.creator.name }}
              </span>
            </a>
            <div
              class="dropdown float-right"
              @click.stop
              style="
                float: right;
                background: transparent !important;
                border: none;
                position: absolute;
                right: 0;
                top: 0;
                margin-right: 10px;
              "
            >
              <button
                class="btn btn-secondary dropdown-toggle remove-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i
                  class="fa fa-ellipsis-v dropdown-toggle"
                  id="icon-open-modal-options"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></i>
              </button>
              <ul
                class="dropdown-menu drop-shadow-none dropdown-options"
                aria-labelledby="dropdownMenuButton1"
                style="z-index: 1000"
              >
                <li>
                  <div
                    class="dropdown-item"
                    id="remove-to-playlist"
                    :data-video-id="video.id"
                    :data-playlist-id="video.playlist_id"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title=""
                    data-original-title="Remove to Playlist"
                    @click="
                      removeToPlaylist(
                        video.id,
                        video.playlist_id,
                        video.episode_id
                      )
                    "
                  >
                    Remove to playlist
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <empty-playlist v-else type="Video" />
  </div>
</template>

<script>
import axios from 'axios';
import EmptyPlaylist from './empty-list.vue';
export default {
  name: 'video-list',
  components: {
    EmptyPlaylist,
  },
  props: {
    playlist: {
      type: Array | Object,
      required: true,
    },
    paths: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emptyPlaylist: false,
    };
  },
  methods: {
    navigateToVideo(video) {
      if (video.episode) {
        window.location.href = `/user/playlist/video/${video.playlist_id}?video=${video.episode_id}`;
      } else {
        window.location.href = `/user/playlist/video/${video.playlist_id}?video=${video.item_id}`;
      }
    },
    goToVideo(video) {
      if (video.episode) {
        window.location.href = `/user/playlist/video/${video.playlist_id}?video=${video.episode_id}`;
      } else {
        window.location.href = `/user/playlist/video/${video.playlist_id}?video=${video.item_id}`;
      }
    },
    async removeToPlaylist(videoId, playlistId, episodeId) {
      try {
        const response = await axios.post(`/user/playlist/removeItem`, {
          video_id: videoId,
          playlist_id: playlistId,
          episode_id: episodeId,
        });
        if (response.status === 200) {
          notify('success', 'Removed from playlist');
          this.$emit('removeFromPlaylist', videoId, 'video');
        } else {
          notify('error', 'Something went wrong');
        }
      } catch (e) {
        notify('error', 'Something went wrong');
        console.log(e);
      }
    },
  },

  mounted() {
    if (this.playlist.length === 0) {
      this.emptyPlaylist = true;
    }
  },
  update() {
    // console.log(this.paths)
  },
};
</script>
